import type { CellState } from '../lib/availability-types';
import { getCellColorClasses, getHatchStyle } from './availability-cell-styles';

export interface LegendItem {
  state: CellState;
  label: string;
}

export interface LegendProps {
  items: LegendItem[];
}

export function Legend({ items }: LegendProps) {
  return (
    <div className="flex items-center gap-3 flex-wrap">
      {items.map(({ state, label }) => (
        <div key={`${state}-${label}`} className="flex items-center gap-1.5">
          <div
            className={`w-4 h-4 rounded-sm border flex-shrink-0 ${getCellColorClasses(state)}`}
            style={getHatchStyle(state)}
          />
          <span className="text-2xs text-muted-foreground">{label}</span>
        </div>
      ))}
    </div>
  );
}
